import React, {useState, useEffect} from 'react';
import MetaTags from 'react-meta-tags';  // Added Meta Tag npm Package
import { Row, Col, Card, CardBody, CardTitle,Label, Input, Badge, Container, Button, Alert, Table, Modal, UncontrolledTooltip } from "reactstrap";
import toastr from "toastr";
import { TOAST_OPTIONS, Config, formatDate } from "helpers/backend_helper";
import "toastr/build/toastr.min.css";
import * as url from "../../helpers/url_helper"
import axios from 'axios';
import { Link } from 'react-router-dom';
import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";
import Select from "react-select"


    const HumanResourceSettings = () => {

        toastr.options = TOAST_OPTIONS;

        const [educationList, setEducationList] = useState(['O level','A Level', 'Tertiary', 'Diploma','Higher Diploma', 'Bachelor\'s Degree', 'Postgraduate Diploma','Masters Degree', 'PhD'])
        const [payGradesList, setPayGradesList] = useState([])
        const [chemicalsList, setChemicalsList] = useState([])

        const [rolesList, setRolesList] = useState([])
        const [titleId, setTitleId] = useState('')
        const [title, setTitle] = useState('')
        const [reportsTo, setReportsTo] = useState('')

        const [isEdit, setIsEdit] = useState(false)
        const [isLoading, setIsLoading] = useState(false)

        const [depts, setDepts] = useState([])
        const [deptId, setDeptId] = useState('')
        const [deptName, setDeptName] = useState('')

        const [districtList, setDistrictList] = useState([])
        const [periodList, setPeriodList] = useState([])
        const [gradeList, setGradeList] = useState([])
        const [disList, setDisList] = useState([])

        const [lineId, setLineId] = useState('')
        const [scaleName, setScaleName] = useState('')
        const [rFrom, setRFrom] = useState('')
        const [rTo, setRTo] = useState('')
        const [frequency, setFrequency] = useState('')

        const [frequencyOption, setFrequencyOptions] = useState(['Monthly','Bi-weekly','Weekly', 'Daily'])
        const [modal_scale, setmodal_scale] = useState(false)
        const [modal_universal_adj, setmodal_universal_adj] = useState(false)
        const [modal_scale_adj, setmodal_scale_adj] = useState(false)
        const [modal_employee_adj, setmodal_employee_adj] = useState(false)
        const [modal_dept, setmodal_dept] = useState(false)
        const [modal_title, setmodal_title] = useState(false)
        const [modal_disc, setmodal_disc] = useState(false)
        const [modal_grade, setmodal_grade] = useState(false)
        const [modal_period, setmodal_period] = useState(false)
        const [modal_approver, setmodal_approver] = useState(false)

        const [discId, setDiscId] = useState('')
        const [discType, setDiscType] = useState('')
        const [discCategory, setDiscCategory] = useState('')
        const [discDescription, setDiscDescription] = useState('')
        const [firstOffenseAction, setFirstOffenseAction] = useState('')
        const [secondOffenceAction, setSecondOffenseAction] = useState('')
        const [thirdOffenseAction, setThirdOffenseAction] = useState('')
        const [fourthOffenseAction, setFourthOffenseAction] = useState('')

        const [typeOptions, setTypeOptions] = useState(['Grievance','Disciplinary'])
        const [categoryOptions, setCategoryOptions] = useState(['Minor','Serious','Gross'])

        const [gradeId, setGradeId] = useState('')
        const [gradeName, setGradeName] = useState('')
        const [gradeCode, setGradeCode] = useState('')
        const [gradeDescription, setGradeDescription] = useState('')
        const [gradeMin, setGradeMin] = useState('')
        const [gradeMax, setGradeMax] = useState('')
        const [gradeAction, setGradeAction] = useState('')

        const [periodId, setPeriodId] = useState('')
        const [periodName , setPeriodName] = useState('')
        const [periodStart, setPeriodStart] = useState([])
        const [periodEnd, setPeriodEnd] = useState([])
        const [periodStatus, setPeriodStatus] = useState('')

        const [appId, setAppId] = useState('')
        const [approverId, setApproverId] = useState('')
        const [approverDeptId, setApproverDeptId] = useState('')
        const [approverRegionId, setApproverRegionId] = useState('')
        const [approvalEntry, setApprovalEntry] = useState('')
        const [approvers, setApprovers] = useState([])
        const [approvalEntries, setApprovalEntries] = useState(['Work order', 'WQ Sample','Production','Leave Plan','Leave','IPA','PA','Disciplinary','Recruitment','Training','Payroll'])
        const [regions, setRegions] = useState([])
        const [users, setUsers] = useState([])

        const [adjType, setAdjType] = useState(['Deduction', 'Allowance'])
        const [adjCat, setAdjCat] = useState(['Tax', 'Contribution', 'Allowance', 'Compensation','Bonus'])
        const [calcMethod, setCalcMethod] = useState(['Percent Gross', 'Percent Basic', 'Fixed', 'Range'])
        const [adjSco, setAdjSco] = useState(['Universal','Scale','Employee', 'Department','Title'])

        const [universalAdjustments, setUniversalAdjustments] = useState([])
        const [scaleAdjustments, setScaleAdjustments] = useState([])
        const [employeeAdjustments, setEmployeeAdjustments] = useState([])

        const [adjustmentScope, setAdjustmentScope] = useState('')
        const [jobTitleId, setJobTitleId] = useState('')
        const [selectedEmployee, setSelectedEmployee] = useState('')
        const [employeeOptions, setEmployeeOptions] = useState([])
        const [scaleId, setScaleId] = useState('')
        const [entryId, setEntryId] = useState('')
        const [adjustmentName, setAdjustmentName] = useState('')
        const [adjustmentType, setAdjustmentType] = useState('')
        const [adjustmentCategory, setAdjustmentCategory] = useState('')
        const [calculationMethod, setCalculationMethod] = useState('') 
        const [percentageValue, setPercentageValue] = useState('')
        const [fixedAmount, setFixedAmount] = useState('')
        const [rangeData, setRangeData] = useState('{"min": 0, "max": 500000, "type": "percentage", "value": 5},{"min": 500001, "max": 1000000, "type": "fixed", "value": 75000}, {"min": 1000001, "max": null, "type": "percentage", "value": 12.5}')
        const [isActive, setIsActive] = useState('Yes')
        const [effectiveDate, setEffectiveDate] = useState([])
        const [endDate, setEndDate] = useState([])
        const [adjustmentDescription, setAdjustmentDescription] = useState('')
        const [userId, setUserId] = useState('')

        const handleSaveUniversal = async () =>{
            const data = {
                id                  : isEdit?entryId:'',
                adjustment_scope    : adjustmentScope,
                employee_id         : adjustmentScope == 'Employee' && selectedEmployee?.value ? selectedEmployee.value : '',
                scale_id            : scaleId,
                dept_id             : deptId,
                title_id            : jobTitleId,
                adjustment_name     : adjustmentName,
                adjustment_type     : adjustmentType,
                adjustment_category : adjustmentCategory,
                calculation_method  : calculationMethod,
                percentage_value    : percentageValue,
                fixed_amount        : fixedAmount,
                range_data          : (calculationMethod == 'Range')? rangeData:'',
                is_active           : isActive,
                effective_date      : effectiveDate[0]?formatDate(effectiveDate):'',
                end_date            : endDate[0]?formatDate(endDate):'',
                adjustment_description         : adjustmentDescription,
                user_id             : userId,
                action              : isEdit?'update':'add'
    
            }
            setIsLoading(true)
            try {
                const r = await axios.post(url.HRPAYADJUSTMENT, JSON.stringify(data), Config)
                if(r.data.status == 1){
                    toastr.success(r.data.message)
                    tog_universal_adj()
                    setEntryId('');setAdjustmentScope(''); setScaleId(''); setDeptId(''); setJobTitleId(''); setSelectedEmployee(null); setAdjustmentName(''); setAdjustmentType('');setAdjustmentCategory('')
                    setCalculationMethod('');setPercentageValue('');setFixedAmount('');setIsActive('Yes');setEffectiveDate([]);setEndDate([]);setAdjustmentDescription('');setIsEdit(false)
                    getData()
                }else{
                    toastr.error(r.data.message) 
                }
            } catch (e){
                console.log(e)
            } finally{
                setIsLoading(false)
            }
        }
        const handleDeleteAdjustment = async (id) =>{
            const data = {
                id                  : id,
                user_id             : userId,
                action              : 'delete'
            }
            setIsLoading(true)
            try {
                const r = await axios.post(url.HRPAYADJUSTMENT, JSON.stringify(data), Config)
                if(r.data.status == 1){
                    toastr.success(r.data.message)
                    getData()
                }else{
                    toastr.error(r.data.message) 
                }
            } catch (e){
                console.log(e)
            } finally{
                setIsLoading(false)
            }
        }


        const removeBodyCss = () => {
            document.body.classList.add("no_padding");
        }
        const tog_scale = () => {
          setmodal_scale(!modal_scale);
          removeBodyCss();
        }
        const tog_universal_adj = () => {
            setmodal_universal_adj(!modal_universal_adj);
            removeBodyCss();
        }
        const tog_grade = () => {
            setmodal_grade(!modal_grade);
            removeBodyCss();
        }
        const tog_period = () => {
            setmodal_period(!modal_period);
            removeBodyCss();
        }
        const tog_approver = () => {
            setmodal_approver(!modal_approver);
            removeBodyCss();
        }
        const tog_dept = () => {
            setmodal_dept(!modal_dept);
            removeBodyCss();
        }
        const tog_title = () => {
            setmodal_title(!modal_title);
            removeBodyCss();
        }
        const tog_disc = () => {
            setmodal_disc(!modal_disc);
            removeBodyCss();
        }

        const handleSaveDept = async () => {
            if (deptName.trim().length < 2) {
                toastr.error("Enter department name");
                return;
            }
            const data = {
                id: isEdit ? deptId : '',
                name: deptName,
                action: isEdit ? "edit" : "add"
            };
            setIsLoading(true);
            try {
                const response = await axios.post(url.DEPTS, JSON.stringify(data), Config);
                if (response.data.status == '1') {
                    toastr.success(response.data.message);
                    tog_dept()
                    setIsEdit(false);
                    setDeptName('');
                    getData(); 
                } else {
                    toastr.error(response.data.message);
                }
            } catch (error) {
                console.error("An error occurred while saving the department:", error);
            } finally {
                setIsLoading(false);
            }
        }
        
        const handleClickDeptDetails = (c) =>{
            setIsEdit(true)
            setDeptId(c.id)
            setDeptName(c.name)
        }
        const handleSaveTitle = async () =>{
            const data = {
                id: isEdit ? titleId : '',
                title: title,
                reportsTo: reportsTo,
                action: isEdit ? 'edit' : 'add'
            };
            try {
                setIsLoading(true);
                const response = await axios.post(url.TITLES, JSON.stringify(data), Config);
                toastr.info(response.data.message);
                setIsEdit(false);
                setTitle('');
                setReportsTo('');
                setTitleId('');
                getData(); 
            } catch (error) {
                console.error("An error occurred while saving the title:", error);
            } finally {
                setIsLoading(false);
            }
        }

        const getData = async () =>{
            setIsLoading(true);
            try {
                if (localStorage.getItem("authWTUser")) {
                    const obj = JSON.parse(localStorage.getItem("authWTUser"));
                    setUserId(obj.id);
                }
                const chemicalsResponse = await axios.get(url.CHEMICALS, Config);
                setChemicalsList(chemicalsResponse.data);
                const titlesResponse = await axios.get(url.TITLES, Config);
                setRolesList(titlesResponse.data);
                const deptsResponse = await axios.get(url.DEPTS, Config);
                setDepts(deptsResponse.data);
                const territoriesResponse = await axios.get(url.TERRITORIES, Config);
                setDistrictList(territoriesResponse.data);
                const payScalesResponse = await axios.get(url.HRPAYSCALES, Config);
                setPayGradesList(payScalesResponse.data);
                const periodResponse = await axios.post(url.HRPAPERIODS, JSON.stringify({action:'filter'}), Config)
                setPeriodList(periodResponse.data)
                const appraisalGradeResponse = await axios.post(url.HRPAGRADES, JSON.stringify({action:'filter'}), Config)
                setGradeList(appraisalGradeResponse.data)
                const d = await axios.post(url.HRDISCIPLINARYSETUP, JSON.stringify({action:'filter'}), Config)
                setDisList(d.data)
                const a = await axios.post(url.APPROVERS, JSON.stringify({action:'filter'}), Config)
                setApprovers(a.data)
                const u = await axios.post(url.USERSFILTER, JSON.stringify({status:'Active'}), Config)
                setUsers(u.data);
                const data = { id  : '', no  : '', nin : '', name: '', phone:'',sex : '', status:'', marital:'', dept: '', category: '', location: '' }
                const em = await axios.post(`${url.HREMPLOYEESFILTER}`, JSON.stringify(data), Config)
                let arr = []; (em.data || []).map((a)=>{ arr.push({'value':a.id, 'label':a.name}) })
                setEmployeeOptions(arr)
                const uni = await axios.post(url.HRPAYADJUSTMENT, JSON.stringify({action:'filter',adjustment_scope:''}), Config)
                setUniversalAdjustments(uni.data)
            } catch (error) {
                console.error("An error occurred while fetching data:", error);
            } finally {
                setIsLoading(false);
            }
        }
        useEffect(() => {
           getData() 
        },[]);

        const handleSaveScale = () =>{
            const data = {
                id: isEdit?lineId:'',
                scaleName: scaleName,
                rFrom: rFrom,
                rTo: rTo,
                frequency: frequency,
                action: isEdit?'edit':'add'
            }
            setIsLoading(true)
            axios.post(url.HRPAYSCALES, JSON.stringify(data), Config).then((r)=>{
                if(r.data.status == '1'){
                    tog_scale();
                    setLineId('')
                    setScaleName('')
                    setRFrom('')
                    setRTo('')
                    setFrequency('')
                    toastr.success(r.data.message)
                    getData()
                }else{
                    toastr.error(r.data.message)
                }
            }).catch((e)=>{
                console.log(e)
            }).finally(()=>{
                setIsLoading(false)
            })
        }
        const handleDeleteScale = (id) =>{
            const data = {
                id: id,
                scaleName: 'xxxx',
                rFrom: 'xxx',
                rTo: 'xxx',
                frequency: 'xxx',
                action: 'delete'
            }
            setIsLoading(true)
            axios.post(url.HRPAYSCALES, JSON.stringify(data), Config).then((r)=>{
                if(r.data.status == '1'){
                    toastr.success(r.data.message)
                    getData()
                }else{
                    toastr.error(r.data.message)
                }
            }).catch((e)=>{
                console.log(e)
            }).finally(()=>{
                setIsLoading(false)
            })
        }
       
        const handleSaveDisc = async () =>{
            const data = {
                id                      : isEdit?discId:'',
                type                    : discType,
                category                : discCategory,
                description             : discDescription,
                first_offence_action    : firstOffenseAction,
                second_offence_action   : secondOffenceAction,
                third_offence_action    : thirdOffenseAction,
                fourth_offence_action   : fourthOffenseAction,
                action                  : isEdit?'update':'add'
            }
            try {
                setIsLoading(true)
                const r = await axios.post(url.HRDISCIPLINARYSETUP, JSON.stringify(data), Config)
                if(r.data.status == '1'){
                    tog_disc();
                    toastr.success(r.data.message)
                    setDiscId('')
                    setDiscType('')
                    setDiscCategory('')
                    setDiscDescription('')
                    setFirstOffenseAction('')
                    setSecondOffenseAction('')
                    setThirdOffenseAction('')
                    setFourthOffenseAction('')
                    getData()
                }else{
                    toastr.error(r.data.message)
                }
            } catch (e) {
                console.log(e)
            } finally {
                setIsLoading(false)
            }
        }
        const handleSaveApprover = async () =>{
            const data = {
                id          : isEdit?appId:'',
                dept_id     : approverDeptId,
                region_id   : 7,
                approver_id : approverId,
                entity      : approvalEntry,
                action      : isEdit?'update':'add'
            }
            try {
                setIsLoading(true)
                const r = await axios.post(url.APPROVERS, JSON.stringify(data), Config)
                if(r.data.status == '1'){
                    tog_approver();
                    toastr.success(r.data.message)
                    setAppId('')
                    setApproverDeptId('')
                    setApproverRegionId('')
                    setApproverId('')
                    setApprovalEntry('')
                    getData()
                }else{
                    toastr.error(r.data.message)
                }
            } catch (e) {
                console.log(e)
            } finally {
                setIsLoading(false)
            }
        }
               
        
        return (
            <>
                <div className="page-content">
                    <MetaTags>
                    <title>HR Settings | {url.COMPANY}</title>
                    </MetaTags>
                    <Container fluid={true}>
                        <div>
                                <Modal isOpen={modal_approver} toggle={() => { tog_approver()  }} size="l" centered backdrop={'static'} >
                                  <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">{isEdit?`Update`:`Add`}{` Approvers` }</h5>
                                    <button type="button"
                                      onClick={() => { setmodal_approver(false); }} className="close" data-dismiss="modal" aria-label="Close">
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                  <div className="modal-body">
                                   <Row > 
                                   <Col md={12}>
                                        <div className="mb-3">
                                            <label>Department</label>
                                            <select className="form-select" value={approverDeptId} onChange={(e)=>setApproverDeptId(e.target.value)}>
                                            <option value=""></option>
                                            {depts.map((r,k)=>(
                                                <option key={k} value={r.id}>{r.name}</option>
                                            ))}
                                            </select>
                                        </div>
                                    </Col>
                                    <Col md={12}>
                                        <div className="mb-3">
                                            <label>Entity</label>
                                            <select className="form-select" value={approvalEntry} onChange={(e)=>setApprovalEntry(e.target.value)}>
                                            <option value=""></option>
                                            {approvalEntries.map((r,k)=>(
                                                <option key={k} value={r}>{r}</option>
                                            ))}
                                            </select>
                                        </div>
                                    </Col>
                                    <Col md={12}>
                                        <div className="mb-3">
                                            <label>Approver</label>
                                            <select className="form-select" value={approverId} onChange={(e)=>setApproverId(e.target.value)}>
                                            <option value=""></option>
                                            {users.map((r,k)=>(
                                                <option key={k} value={r.id}>{r.name} - {r.deptName}</option>
                                            ))}
                                            </select>
                                        </div>
                                    </Col>
                                   </Row>
                                  </div>
                                  <div className="modal-footer">
                                  {isLoading?`Please wait...`:(<>
                                    <button onClick={() => {  tog_approver() }} className="btn btn-danger" data-dismiss="modal">Cancel</button>
                                    <button className="btn btn-success" onClick={handleSaveApprover}   >Save</button>
                                    </>)}
                                  </div>
                                </Modal>
                                <Modal isOpen={modal_period} toggle={() => { tog_period()  }} size="l" centered backdrop={'static'} >
                                  <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">{isEdit?`Update`:`Add`}{` Appraisal Period` }</h5>
                                    <button type="button"
                                      onClick={() => { setmodal_period(false); }} className="close" data-dismiss="modal" aria-label="Close">
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                  <div className="modal-body">
                                   <Row > 
                                    <Col md={12}>
                                        <div className="mb-3">
                                            <label>Name</label>
                                            <input type='text' className="form-control" value={periodName} onChange={(e)=>setPeriodName(e.target.value)} />
                                        </div>
                                    </Col>
                                    <Col xl={6}>
                                        <div className="mb-3">
                                            <label>Period Start Date</label>
                                            <Flatpickr
                                                className="form-control"
                                                options={{
                                                    dateFormat: "Y-m-d",
                                                    enableTime: false
                                                }}
                                                value={periodStart}
                                                onChange={(dates)=>{setPeriodStart(dates); }}
                                                />
                                        </div>
                                    </Col>
                                    <Col xl={6}>
                                        <div className="mb-3">
                                            <label>Period End Date</label>
                                            <Flatpickr
                                                className="form-control"
                                                options={{
                                                    dateFormat: "Y-m-d",
                                                    enableTime: false
                                                }}
                                                value={periodEnd}
                                                onChange={(dates)=>{setPeriodEnd(dates); }}
                                                />
                                        </div>
                                    </Col>
                                    <Col xl={12}>
                                        <div className="mb-3">
                                            <label>Period Status</label>
                                            <select className="form-select" value={periodStatus} onChange={(e)=>setPeriodStatus(e.target.value)}>
                                            <option value=''></option>
                                            <option value='Open'>Open</option>
                                            <option value='Closed'>Closed</option>
                                            </select>
                                        </div>
                                    </Col>
                                   </Row>
                                  </div>
                                  <div className="modal-footer">
                                  {isLoading?`Please wait...`:(<>
                                    <button onClick={() => {  tog_grade() }} className="btn btn-danger" data-dismiss="modal">Cancel</button>
                                    <button className="btn btn-success"   >Save</button>
                                    </>)}
                                  </div>
                                </Modal>
                                <Modal isOpen={modal_grade} toggle={() => { tog_grade()  }} size="l" centered backdrop={'static'} >
                                  <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">{isEdit?`Update`:`Add`}{` Appraisal Grading` }</h5>
                                    <button type="button"
                                      onClick={() => { setmodal_grade(false); }} className="close" data-dismiss="modal" aria-label="Close">
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                  <div className="modal-body">
                                   <Row > 
                                    <Col md={12}>
                                        <div className="mb-3">
                                            <label>Grade</label>
                                            <input type='text' className="form-control" value={gradeName} onChange={(e)=>setGradeName(e.target.value)} />
                                        </div>
                                    </Col>
                                    <Col md={12}>
                                        <div className="mb-3">
                                            <label>Code</label>
                                            <input type='text' className="form-control" value={gradeCode} onChange={(e)=>setGradeCode(e.target.value)} />
                                        </div>
                                    </Col>
                                    <Col md={12}>
                                        <div className="mb-3">
                                            <label>Grade Description</label>
                                            <input type='text' className="form-control" value={gradeDescription} onChange={(e)=>setGradeDescription(e.target.value)} />
                                        </div>
                                    </Col>
                                    <Col md={6}>
                                        <div className="mb-3">
                                            <label>Minimum Score</label>
                                            <input type='text' className="form-control" value={gradeMin} onChange={(e)=>setGradeMin(e.target.value)} />
                                        </div>
                                    </Col>
                                    <Col md={6}>
                                        <div className="mb-3">
                                            <label>Maximum Score</label>
                                            <input type='text' className="form-control" value={gradeMax} onChange={(e)=>setGradeMax(e.target.value)} />
                                        </div>
                                    </Col>
                                    <Col md={12}>
                                        <div className="mb-3">
                                            <label>Grade Description</label>
                                            <input type='text' className="form-control" value={gradeDescription} onChange={(e)=>setGradeDescription(e.target.value)} />
                                        </div>
                                    </Col>
                                   </Row>
                                  </div>
                                  <div className="modal-footer">
                                  {isLoading?`Please wait...`:(<>
                                    <button onClick={() => {  tog_grade() }} className="btn btn-danger" data-dismiss="modal">Cancel</button>
                                    <button className="btn btn-success"   >Save</button>
                                    </>)}
                                  </div>
                                </Modal>
                                <Modal isOpen={modal_disc} toggle={() => { tog_disc()  }} size="l" centered backdrop={'static'} >
                                  <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">{isEdit?`Update`:`Add`}{` Disciplinary and Grievance settings` }</h5>
                                    <button type="button"
                                      onClick={() => { setmodal_disc(false); }} className="close" data-dismiss="modal" aria-label="Close">
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                  <div className="modal-body">
                                   <Row > 
                                    
                                    <Col md={12}>
                                        <div className="mb-3">
                                            <label>Type</label>
                                            <select className="form-select" value={discType} onChange={(e)=>setDiscType(e.target.value)}>
                                            <option value=""></option>
                                            {typeOptions.map((r,k)=>(
                                                <option key={k} value={r}>{r}</option>
                                            ))}
                                            </select>
                                        </div>
                                    </Col>
                                    <Col md={12}>
                                        <div className="mb-3">
                                            <label>Category</label>
                                            <select className="form-select" value={discCategory} onChange={(e)=>setDiscCategory(e.target.value)}>
                                            <option value=""></option>
                                            {categoryOptions.map((r,k)=>(
                                                <option key={k} value={r}>{r}</option>
                                            ))}
                                            </select>
                                        </div>
                                    </Col>
                                    <Col md={12}>
                                        <div className="mb-3">
                                            <label>Description</label>
                                            <input type='text' className="form-control" value={discDescription} onChange={(e)=>setDiscDescription(e.target.value)} />
                                        </div>
                                    </Col>
                                    <Col md={12}>
                                        <div className="mb-3">
                                            <label>First Offense Action</label>
                                            <input type='text' className="form-control" value={firstOffenseAction} onChange={(e)=>setFirstOffenseAction(e.target.value)} />
                                        </div>
                                    </Col>
                                    <Col md={12}>
                                        <div className="mb-3">
                                            <label>Second Offense Action</label>
                                            <input type='text' className="form-control" value={secondOffenceAction} onChange={(e)=>setSecondOffenseAction(e.target.value)} />
                                        </div>
                                    </Col>
                                    <Col md={12}>
                                        <div className="mb-3">
                                            <label>Third Offense Action</label>
                                            <input type='text' className="form-control" value={thirdOffenseAction} onChange={(e)=>setThirdOffenseAction(e.target.value)} />
                                        </div>
                                    </Col>
                                    <Col md={12}>
                                        <div className="mb-3">
                                            <label>Forth Offense Action</label>
                                            <input type='text' className="form-control" value={fourthOffenseAction} onChange={(e)=>setFourthOffenseAction(e.target.value)} />
                                        </div>
                                    </Col>
                                   </Row>
                                  </div>
                                  <div className="modal-footer">
                                  {isLoading?`Please wait...`:(<>
                                    <button onClick={() => {  tog_disc() }} className="btn btn-danger" data-dismiss="modal">Cancel</button>
                                    <button className="btn btn-success" onClick={handleSaveDisc}  >Save</button>
                                    </>)}
                                  </div>
                                </Modal>
                                <Modal isOpen={modal_title} toggle={() => { tog_title()  }} size="l" centered backdrop={'static'} >
                                  <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">{isEdit?`Update`:`Add`}{` Title` }</h5>
                                    <button type="button"
                                      onClick={() => { setmodal_title(false); }} className="close" data-dismiss="modal" aria-label="Close">
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                  <div className="modal-body">
                                   <Row > 
                                    <Col xl={12}>
                                        <div className="mb-3">
                                            <label>Title</label>
                                            <input type='text' className="form-control" value={title} onChange={(e)=>setTitle(e.target.value)} />
                                        </div>
                                    </Col>
                                    <Col md={12}>
                                            <div className="mb-3">
                                                <label>Reports to</label>
                                                <select className="form-select" value={reportsTo} onChange={(e)=>setReportsTo(e.target.value)}>
                                                <option value=""></option>
                                                {rolesList.map((r,k)=>(
                                                    <option key={k} value={r.id}>{r.title}</option>
                                                ))}
                                                </select>
                                            </div>
                                    </Col>
                                   </Row>
                                  </div>
                                  <div className="modal-footer">
                                  {isLoading?`Please wait...`:(<>
                                    <button onClick={() => {  tog_title() }} className="btn btn-danger" data-dismiss="modal">Cancel</button>
                                    <button className="btn btn-success" onClick={handleSaveTitle}  >Save</button>
                                    </>)}
                                  </div>
                                </Modal>
                                <Modal isOpen={modal_dept} toggle={() => { tog_dept()  }} size="l" centered backdrop={'static'} >
                                  <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">{isEdit?`Update`:`Add`}{` Department` }</h5>
                                    <button type="button"
                                      onClick={() => { setmodal_dept(false); }} className="close" data-dismiss="modal" aria-label="Close">
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                  <div className="modal-body">
                                   <Row > 
                                    <Col xl={12}>
                                        <div className="mb-3">
                                            <label>Department Name</label>
                                            <input type='text' className="form-control" value={deptName} onChange={(e)=>setDeptName(e.target.value)} />
                                        </div>
                                    </Col>
                                
                                   </Row>
                                  </div>
                                  <div className="modal-footer">
                                  {isLoading?`Please wait...`:(<>
                                    <button onClick={() => {  tog_dept() }} className="btn btn-danger" data-dismiss="modal">Cancel</button>
                                    <button className="btn btn-success" onClick={handleSaveDept}  >Save</button>
                                    </>)}
                                  </div>
                                </Modal>

                                <Modal isOpen={modal_scale} toggle={() => { tog_scale()  }} size="l" centered backdrop={'static'} >
                                  <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">{isEdit?`Update`:`Add`}{` Pay Grade` }</h5>
                                    <button type="button"
                                      onClick={() => { setmodal_scale(false); }} className="close" data-dismiss="modal" aria-label="Close">
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                  <div className="modal-body">
                                 
                                  <Row > 
                                    <Col xl={6}>
                                        <div className="mb-3">
                                            <label>Grade Name</label>
                                            <input type='text' className="form-control" value={scaleName} onChange={(e)=>setScaleName(e.target.value)} />
                                        </div>
                                    </Col>
                                    <Col xl={6}>
                                        <div className="mb-3">
                                            <label>Pay frequency</label>
                                            <select className="form-select" value={frequency} onChange={(e)=>setFrequency(e.target.value)} >
                                                <option value=''></option>
                                                  {(frequencyOption || []).map((t,k)=>(
                                                    <option key={k} value={t}>{t}</option>
                                                  ))}
                                            </select>
                                        </div>
                                    </Col>
                                    <Col xl={6}>
                                        <div className="mb-3">
                                            <label>From (Amount)</label>
                                            <input type='number' className="form-control" value={rFrom} onChange={(e)=>setRFrom(e.target.value)} />
                                        </div>
                                    </Col>
                                    <Col xl={6}>
                                        <div className="mb-3">
                                            <label>To (Amount)</label>
                                            <input type='number' className="form-control" value={rTo} onChange={(e)=>setRTo(e.target.value)} />
                                        </div>
                                    </Col>
                                    
                         
                                  </Row>
                                  </div>
                                  <div className="modal-footer">
                                  {isLoading?`Please wait...`:(<>
                                    <button onClick={() => {  tog_scale() }} className="btn btn-danger" data-dismiss="modal">Cancel</button>
                                    <button className="btn btn-success" onClick={handleSaveScale}  >Save...</button>
                                    </>)}
                                  </div>
                                </Modal>

                                <Modal isOpen={modal_universal_adj} toggle={() => { tog_universal_adj()  }} size="xl" centered backdrop={'static'} >
                                  <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">{isEdit?`Update`:`Add`}{` Pay Adjustment` }</h5>
                                    <button type="button"
                                      onClick={() => { setmodal_universal_adj(false); }} className="close" data-dismiss="modal" aria-label="Close">
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                  <div className="modal-body">
                                  <Row > 
                                  <Col xl={6}>
                                        <div className="mb-3">
                                            <label>Adjustment Scope</label>
                                            <select className="form-select" value={adjustmentScope} onChange={(e)=>setAdjustmentScope(e.target.value)} >
                                                <option value=''></option>
                                                  {(adjSco || []).map((t,k)=>(
                                                    <option key={k} value={t}>{t}</option>
                                                  ))}
                                            </select>
                                        </div>
                                    </Col>
                                    {(adjustmentScope == 'Department') && (
                                        <Col xl={6}>
                                         <div className="mb-3">
                                             <label>Department</label>
                                             <select className="form-select" value={deptId} onChange={(e)=>setDeptId(e.target.value)}>
                                                <option></option>
                                                {depts.map((d,k)=>(
                                                    <option key={k} value={d.id}>{d.name}</option>
                                                ))}
                                             </select>
                                         </div>
                                        </Col>
                                    )}
                                    {(adjustmentScope == 'Title') && (
                                        <Col xl={6}>
                                         <div className="mb-3">
                                             <label>Job Title</label>
                                             <select className="form-select" value={jobTitleId} onChange={(e)=>setJobTitleId(e.target.value)}>
                                                <option></option>
                                                {rolesList.map((r,k)=>(
                                                    <option key={k} value={r.id}>{r.title}</option>
                                                ))}
                                             </select>
                                         </div>
                                        </Col>
                                    )}
                                    {(adjustmentScope == 'Scale') && (
                                        <Col xl={6}>
                                         <div className="mb-3">
                                             <label>Pay Grade/Scale</label>
                                             <select className="form-select" value={scaleId} onChange={(e)=>setScaleId(e.target.value)}>
                                                <option></option>
                                                {payGradesList.map((d,k)=>(
                                                    <option key={k} value={d.id}>{d.name}</option>
                                                ))}
                                             </select>
                                         </div>
                                        </Col>
                                    )}
                                    {(adjustmentScope == 'Employee') && (
                                        <Col xl={6}>
                                         <div className="mb-3">
                                             <label>Employee Name</label>
                                             <Select value={selectedEmployee} onChange={(oo)=>{setSelectedEmployee(oo);  }} options={employeeOptions} isSearchable/>
                                         </div>
                                        </Col>
                                    )}
                                    <Col xl={6}>
                                        <div className="mb-3">
                                            <label>Adjustment Name</label>
                                            <input type='text' className="form-control" value={adjustmentName} onChange={(e)=>setAdjustmentName(e.target.value)} />
                                        </div>
                                    </Col>
                                    <Col xl={12}>
                                        <div className="mb-3">
                                            <label>Adjustment Description</label>
                                            <textarea className="form-control" value={adjustmentDescription} onChange={(e)=>setAdjustmentDescription(e.target.value)} />
                                        </div>
                                    </Col>
                                    <Col xl={6}>
                                        <div className="mb-3">
                                            <label>Adjustment Type</label>
                                            <select className="form-select" value={adjustmentType} onChange={(e)=>setAdjustmentType(e.target.value)} >
                                                <option value=''></option>
                                                  {(adjType || []).map((t,k)=>(
                                                    <option key={k} value={t}>{t}</option>
                                                  ))}
                                            </select>
                                        </div>
                                    </Col>
                                    <Col xl={6}>
                                        <div className="mb-3">
                                            <label>Adjustment Category</label>
                                            <select className="form-select" value={adjustmentCategory} onChange={(e)=>setAdjustmentCategory(e.target.value)} >
                                                <option value=''></option>
                                                  {(adjCat || []).map((t,k)=>(
                                                    <option key={k} value={t}>{t}</option>
                                                  ))}
                                            </select>
                                        </div>
                                    </Col>
                                    <Col xl={6}>
                                        <div className="mb-3">
                                            <label>Calculation Method</label>
                                            <select className="form-select" value={calculationMethod} onChange={(e)=>setCalculationMethod(e.target.value)} >
                                                <option value=''></option>
                                                  {(calcMethod || []).map((t,k)=>(
                                                    <option key={k} value={t}>{t}</option>
                                                  ))}
                                            </select>
                                        </div>
                                    </Col>
                                    {['Percent Gross', 'Percent Basic'].includes(calculationMethod) && (
                                        <Col xl={6}>
                                            <div className="mb-3">
                                                <label>Percentage value (0 - 100)</label>
                                                <input type='number' className="form-control" value={percentageValue} onChange={(e)=>setPercentageValue(e.target.value)} />
                                            </div>
                                        </Col>
                                    )}
                                    {['Fixed'].includes(calculationMethod) && (
                                    <Col xl={6}>
                                        <div className="mb-3">
                                            <label>Fixed Amount</label>
                                            <input type='number' className="form-control" value={fixedAmount} onChange={(e)=>setFixedAmount(e.target.value)} />
                                        </div>
                                    </Col>
                                    )}
                                    {['Range'].includes(calculationMethod) && (
                                    <Col xl={12}>
                                        <div className="mb-3">
                                            <label>Range </label>
                                            <textarea className="form-control" rows={4} value={rangeData} onChange={(e)=>setRangeData(e.target.value)} />
                                        </div>
                                    </Col>
                                    )}
                                    </Row>
                                    <Row> 
                                    <Col xl={4}>
                                            <div className="mb-3">
                                                <label>Is Active</label>
                                                <select className="form-select" value={isActive} onChange={(e)=>setIsActive(e.target.value)}>
                                                    <option value="Yes">Yes</option>
                                                    <option value="No">No</option>
                                                </select>
                                            </div>
                                        </Col>                                   
                                        <Col xl={4}>
                                        <div className="mb-3">
                                            <label>Start Date</label>
                                            <Flatpickr
                                                className="form-control"
                                                options={{
                                                    dateFormat: "Y-m-d",
                                                    enableTime: false
                                                }}
                                                value={effectiveDate}
                                                onChange={(dates)=>{setEffectiveDate(dates); }}
                                                />
                                        </div>
                                    </Col>
                                    <Col xl={4}>
                                        <div className="mb-3">
                                            <label>End Date</label>
                                            <Flatpickr
                                                className="form-control"
                                                options={{
                                                    dateFormat: "Y-m-d",
                                                    enableTime: false
                                                }}
                                                value={endDate}
                                                onChange={(dates)=>{setEndDate(dates); }}
                                                />
                                        </div>
                                    </Col>
                         
                                  </Row>
                                  </div>
                                  <div className="modal-footer">
                                  {isLoading?`Please wait...`:(<>
                                    <button onClick={() => {  tog_universal_adj() }} className="btn btn-danger" data-dismiss="modal">Cancel</button>
                                    <button className="btn btn-success" onClick={handleSaveUniversal}  >Save...</button>
                                    </>)}
                                  </div>
                                </Modal>


                        <Row>
                        <Col xl={12}>
                        <Card>
                            <h5 className="card-header bg-transparent border-bottom text-uppercase">DISCIPLINARY AND GRIEVANCE SETTINGS</h5>
                                <CardBody>
                                <Row className="justify-content-center">
                                
                                {((disList || []).length > 0) ? (
                                <div className="table-responsive">
                                        <table className="table table-striped table-sm mb-4 table-nowrap align-middle table-hover">
                                            <thead>
                                            <tr>
                                            <th>No</th>
                                            <th>Type</th>
                                            <th>Category</th>
                                            <th>Description</th>
                                            <th>First Offence</th>
                                        
                                          
                                            <th></th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {(disList || []).map((l,k)=>(
                                            <tr key={k}>
                                
                                                <td>{k+1}</td>
                                                <td>{l.type}</td>
                                                <td>{l.category}</td>
                                                <td>{l.description}</td>
                                                <td>{l.first_offence_action}</td>
                                               
                                                <td style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '1rem' }}> <>
                                                    <div className="d-flex gap-3">
                                                        <Link
                                                        to="#"
                                                        className="text-success"
                                                        onClick={() => {
                                                            setIsEdit(true)
                                                            tog_disc();
                                                            setDiscId(l.id)
                                                            setDiscType(l.type)
                                                            setDiscCategory(l.category)
                                                            setDiscDescription(l.description)
                                                            setFirstOffenseAction(l.first_offence_action)
                                                            setSecondOffenseAction(l.second_offence_action)
                                                            setThirdOffenseAction(l.third_offence_action)
                                                            setFourthOffenseAction(l.fourth_offence_action)
                                                        }}
                                                        >
                                                        <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
                                                        <UncontrolledTooltip placement="top" target="edittooltip">
                                                            Edit
                                                        </UncontrolledTooltip>
                                                        </Link>
                                                        <Link
                                                        to="#"
                                                        className="text-danger"
                                                        //onClick={() => handleDeleteJobH(l)}
                                                        >
                                                        <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
                                                        <UncontrolledTooltip placement="top" target="deletetooltip">
                                                            Delete
                                                        </UncontrolledTooltip>
                                                        </Link>
                                                    </div>
                                                    </></td>
                                                </tr>
                                            ))}
                                            </tbody>
                                        </table>
                                        </div>
                                    ):(
                                        <div className="text-center">
                                            <div className="mb-4">
                                                    <i className="mdi mdi-check-circle-outline text-warning display-4" />
                                                    </div>
                                                    <div>
                                                    <h6>No Disciplinary action Set</h6>
                                                    <p className="text-muted">
                                                            
                                                    </p>
                                            </div>
                                        </div>
                                    )} 
                                    <div className="col-auto">
                                    {isLoading?<Button color="warning" type="button" className="btn-rounded btn-sm">Please wait...</Button>:<Button color="primary" className="btn-sm btn-rounded" 
                                        onClick={() =>{ tog_disc(); setIsEdit(false); setDiscId(''); setDiscType(''); setDiscCategory(''); setDiscDescription(''); setFirstOffenseAction(''); setSecondOffenseAction(''); setThirdOffenseAction(''); setFourthOffenseAction('') }}
                                        >
                                        <span className="d-none d-sm-inline-block me-2">Add Disciplinary Action</span></Button>}
                                    </div> 
                                    
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col xl={12}>
                        <Card>
                            <h5 className="card-header bg-transparent border-bottom text-uppercase">APPRAISAL GRADING SETTINGS</h5>
                                <CardBody>
                                <Row className="justify-content-center">
                                
                                {((gradeList || []).length > 0) ? (
                                <div className="table-responsive">
                                        <table className="table table-striped table-sm mb-4 table-nowrap align-middle table-hover">
                                            <thead>
                                            <tr>
                                            <th>No</th>
                                            <th>Name</th>
                                            <th>Code</th>
                                            <th>Description</th>
                                            <th>Range</th>
                                            <th>Action</th>
                                            <th></th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {(gradeList || []).map((l,k)=>(
                                            <tr key={k}>
                                
                                                <td>{k+1}</td>
                                                <td>{l.grade_name}</td>
                                                <td>{l.grade_code}</td>
                                                <td>{l.description}</td>
                                                <td>{l.min_score} - {l.max_score}</td>
                                                <td>{l.action}</td>
                                                <td style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '1rem' }}> <>
                                                    <div className="d-flex gap-3">
                                                        <Link
                                                        to="#"
                                                        className="text-success"
                                                        onClick={() =>{
                                                            tog_grade(); setIsEdit(true); setGradeId(l.id); setGradeName(l.grade_name); setGradeCode(l.grade_code); setGradeDescription(l.description); setGradeMin(l.min_score); setGradeMax(l.max_score); setGradeAction(l.action);
                                                        }}
                                                        >
                                                        <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
                                                        <UncontrolledTooltip placement="top" target="edittooltip">
                                                            Edit
                                                        </UncontrolledTooltip>
                                                        </Link>
                                                        <Link
                                                        to="#"
                                                        className="text-danger"
                                                        //onClick={() => handleDeleteJobH(l)}
                                                        >
                                                        <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
                                                        <UncontrolledTooltip placement="top" target="deletetooltip">
                                                            Delete
                                                        </UncontrolledTooltip>
                                                        </Link>
                                                    </div>
                                                    </></td>
                                                </tr>
                                            ))}
                                            </tbody>
                                        </table>
                                        </div>
                                    ):(
                                        <div className="text-center">
                                            <div className="mb-4">
                                                    <i className="mdi mdi-check-circle-outline text-warning display-4" />
                                                    </div>
                                                    <div>
                                                    <h6>No Grading Set</h6>
                                                    <p className="text-muted">
                                                            
                                                    </p>
                                            </div>
                                        </div>
                                    )} 
                                    <div className="col-auto">
                                    {isLoading?<Button color="warning" type="button" className="btn-rounded btn-sm">Please wait...</Button>:<Button color="primary" className="btn-sm btn-rounded" 
                                        onClick={() =>{ tog_grade(); setIsEdit(false); setGradeId(''); setGradeName(''); setGradeCode(''); setGradeDescription(''); setGradeMin(''); setGradeMax(''); setGradeAction(''); }}
                                        >
                                        <span className="d-none d-sm-inline-block me-2">Add Appraisal Grade</span></Button>}
                                    </div> 
                                    
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col xl={6}>
                        <Card>
                            <h5 className="card-header bg-transparent border-bottom text-uppercase">APPRAISAL PERIODS</h5>
                                <CardBody>
                                <Row className="justify-content-center">
                                
                                {((periodList || []).length > 0) ? (
                                <div className="table-responsive">
                                        <table className="table table-striped table-sm mb-4 table-nowrap align-middle table-hover">
                                            <thead>
                                            <tr>
                                            <th>No</th>
                                            <th>Name</th>
                                            <th>Start</th>
                                            <th>End</th>
                                            <th>Status</th>
                                            <th></th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {(periodList || []).map((l,k)=>(
                                            <tr key={k}>
                                
                                                <td>{k+1}</td>
                                                <td>{l.name}</td>
                                                <td>{l.start_date}</td>
                                                <td>{l.end_date}</td>
                                                <td>{l.status}</td>
                                                <td style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '1rem' }}> <>
                                                    <div className="d-flex gap-3">
                                                        <Link
                                                        to="#"
                                                        className="text-success"
                                                        //onClick={() => handleEditJobH(l)}
                                                        >
                                                        <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
                                                        <UncontrolledTooltip placement="top" target="edittooltip">
                                                            Edit
                                                        </UncontrolledTooltip>
                                                        </Link>
                                                        <Link
                                                        to="#"
                                                        className="text-danger"
                                                        //onClick={() => handleDeleteJobH(l)}
                                                        >
                                                        <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
                                                        <UncontrolledTooltip placement="top" target="deletetooltip">
                                                            Delete
                                                        </UncontrolledTooltip>
                                                        </Link>
                                                    </div>
                                                    </></td>
                                                </tr>
                                            ))}
                                            </tbody>
                                        </table>
                                        </div>
                                    ):(
                                        <div className="text-center">
                                            <div className="mb-4">
                                                    <i className="mdi mdi-check-circle-outline text-warning display-4" />
                                                    </div>
                                                    <div>
                                                    <h6>No Appraisal Period set</h6>
                                                    <p className="text-muted">
                                                            
                                                    </p>
                                            </div>
                                        </div>
                                    )} 
                                    <div className="col-auto">
                                    {isLoading?<Button color="warning" type="button" className="btn-rounded btn-sm">Please wait...</Button>:<Button color="primary" className="btn-sm btn-rounded" 
                                        onClick={() =>{ tog_period(); setIsEdit(false); setPeriodId(''); setPeriodName(''); setPeriodStart([]); setPeriodEnd([]); setPeriodStatus('') }}
                                        >
                                        <span className="d-none d-sm-inline-block me-2">Add Period</span></Button>}
                                    </div> 
                                    
                                    </Row>
                                </CardBody>
                            </Card>

                            <Card>
                            <h5 className="card-header bg-transparent border-bottom text-uppercase">APPROVERS</h5>
                                <CardBody>
                                <Row className="justify-content-center">
                                
                                {((approvers || []).length > 0) ? (
                                <div className="table-responsive">
                                        <table className="table table-striped table-sm mb-4 table-nowrap align-middle table-hover">
                                            <thead>
                                            <tr>
                                            <th>No</th>
                                            <th>Department</th>
                                            <th>Entity</th>
                                            <th>Approver Name</th>
                                            <th></th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {(approvers || []).map((l,k)=>(
                                            <tr key={k}>
                                
                                                <td>{k+1}</td>
                                                <td>{l.dept}</td>
                                                <td>{l.entity}</td>
                                                <td>{l.user_name}</td>
                                                <td style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '1rem' }}> <>
                                                    <div className="d-flex gap-3">
                                                        <Link
                                                        to="#"
                                                        className="text-success"
                                                        onClick={() =>{
                                                            tog_approver(); setIsEdit(true); setAppId(l.id); setApproverDeptId(l.dept_id); setApprovalEntry(l.entity); setApproverId(l.approver_id); setApproverRegionId(l.region_id) 
                                                        }}
                                                        >
                                                        <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
                                                        <UncontrolledTooltip placement="top" target="edittooltip">
                                                            Edit
                                                        </UncontrolledTooltip>
                                                        </Link>
                                                        <Link
                                                        to="#"
                                                        className="text-danger"
                                                        //onClick={() => handleDeleteJobH(l)}
                                                        >
                                                        <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
                                                        <UncontrolledTooltip placement="top" target="deletetooltip">
                                                            Delete
                                                        </UncontrolledTooltip>
                                                        </Link>
                                                    </div>
                                                    </></td>
                                                </tr>
                                            ))}
                                            </tbody>
                                        </table>
                                        </div>
                                    ):(
                                        <div className="text-center">
                                            <div className="mb-4">
                                                    <i className="mdi mdi-check-circle-outline text-warning display-4" />
                                                    </div>
                                                    <div>
                                                    <h6>No Approver set</h6>
                                                    <p className="text-muted">
                                                            
                                                    </p>
                                            </div>
                                        </div>
                                    )} 
                                    <div className="col-auto">
                                    {isLoading?<Button color="warning" type="button" className="btn-rounded btn-sm">Please wait...</Button>:<Button color="primary" className="btn-sm btn-rounded" 
                                        onClick={() =>{ tog_approver(); setIsEdit(false); setAppId(''); setApproverDeptId(''); setApprovalEntry(''); setApproverId(''); setApproverRegionId('') }}
                                        >
                                        <span className="d-none d-sm-inline-block me-2">Add Approver</span></Button>}
                                    </div> 
                                    
                                    </Row>
                                </CardBody>
                            </Card>

                            <Card>
                        <h5 className="card-header bg-transparent border-bottom text-uppercase">Pay Grades/Scales</h5>
                            <CardBody>
                                <Row className="justify-content-center">
                                    <div className="table-responsive">
                                        <Table className="table table-sm mb-3 table-hover">
                                        <thead>
                                            <tr>
                                            <th>No</th>
                                            <th>Grade</th>
                                            <th>From</th>
                                            <th>To</th>
                                            <th>Frequency</th>
                                            <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                        {payGradesList.map((d,k)=>(
                                            <tr key={k}>
                                                <th scope="row">{k+1}</th>
                                                <td>{d.name}</td>
                                                <td>{parseFloat(d.rFrom).toLocaleString()}</td>
                                                <td>{parseFloat(d.rTo).toLocaleString()}</td>
                                                <td>{d.frequency}</td>
                                                <td style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '1rem' }}> <>
                                                    <div className="d-flex gap-3">
                                                        <Link
                                                        to="#"
                                                        className="text-success"
                                                        onClick={()=>{ setIsEdit(true); tog_scale(); setLineId(d.id); setScaleName(d.name); setRFrom(d.rFrom); setRTo(d.rTo); setFrequency(d.frequency);  }}
                                                        >
                                                        <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
                                                        <UncontrolledTooltip placement="top" target="edittooltip">
                                                            Edit
                                                        </UncontrolledTooltip>
                                                        </Link>
                                                        <Link
                                                        to="#"
                                                        className="text-danger"
                                                        onClick={() => handleDeleteScale(d.id)}
                                                        >
                                                        <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
                                                        <UncontrolledTooltip placement="top" target="deletetooltip">
                                                            Delete
                                                        </UncontrolledTooltip>
                                                        </Link>
                                                    </div>
                                                    </></td>
                                            </tr>
                                        ))}
                                            
                                        </tbody>
                                        </Table>
                                    </div>
                                    
                                    <div className="col-auto">
                                    {isLoading?<Button color="warning" type="button" className="btn-rounded btn-sm">Please wait...</Button>:<Button color="primary" className="btn-sm btn-rounded"
                                        onClick={()=>{ setIsEdit(false); tog_scale(); setLineId(''); setScaleName(''); setRFrom(''); setRTo(''); setFrequency('Monthly');  }}
                                        >
                                        <span className="d-none d-sm-inline-block me-2">Add Pay Scale/Grade</span></Button>}
                                    </div> 
                                    
                                </Row>
                                </CardBody>
                            </Card>

                            <Card>
                        <h5 className="card-header bg-transparent border-bottom text-uppercase">Pay Adjustments</h5>
                            <CardBody>
                                <Row className="justify-content-center">
                                    <div className="table-responsive">
                                        <Table className="table table-sm mb-3 table-hover">
                                        <thead>
                                            <tr>
                                            <th>No</th>
                                            <th>Scope</th>
                                            <th>Name</th>
                                            <th>Type</th>
                                            <th>Method</th>
                                            <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                        {universalAdjustments.map((d,k)=>(
                                            <tr key={k}>
                                                <th scope="row">{k+1}</th>
                                                <td>{d.adjustment_scope}</td>
                                                <td>{d.adjustment_name}</td>
                                                <td>{d.adjustment_type}</td>
                                                <td>{d.calculation_method}</td>
                                                <td style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '1rem' }}> <>
                                                    <div className="d-flex gap-3">
                                                        <Link
                                                        to="#"
                                                        className="text-success"
                                                        onClick={()=>{ 
                                                            setIsEdit(true); 
                                                            tog_universal_adj(); 
                                                            setEntryId(d.id);
                                                            setAdjustmentScope(d.adjustment_scope); setScaleId(d.scale_id); setDeptId(d.dept_id); setJobTitleId(d.title_id); 
                                                            setSelectedEmployee(employeeOptions.find(opt => parseInt(opt.value) == d.employee_id)); setAdjustmentName(d.adjustment_name); setAdjustmentType(d.adjustment_type);setAdjustmentCategory(d.adjustment_category);
                                                            setCalculationMethod(d.calculation_method);setPercentageValue(d.percentage_value);setFixedAmount(d.fixed_amount);setIsActive(d.is_active);
                                                            setEffectiveDate((d.effective_date != '0000-00-00')?[new Date(d.effective_date)]:'');
                                                            setEndDate((d.end_date != '0000-00-00')?[new Date(d.end_date)]:'');setAdjustmentDescription(d.adjustment_description); }}
                                                        >
                                                        <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
                                                        <UncontrolledTooltip placement="top" target="edittooltip">
                                                            Edit
                                                        </UncontrolledTooltip>
                                                        </Link>
                                                        <Link
                                                        to="#"
                                                        className="text-danger"
                                                        onClick={() => handleDeleteAdjustment(d.id)}
                                                        >
                                                        <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
                                                        <UncontrolledTooltip placement="top" target="deletetooltip">
                                                            Delete
                                                        </UncontrolledTooltip>
                                                        </Link>
                                                    </div>
                                                    </></td>
                                            </tr>
                                        ))}
                                            
                                        </tbody>
                                        </Table>
                                    </div>
                                    
                                    <div className="col-auto">
                                    {isLoading?<Button color="warning" type="button" className="btn-rounded btn-sm">Please wait...</Button>:<Button color="primary" className="btn-sm btn-rounded"
                                        onClick={()=>{ setIsEdit(false); tog_universal_adj(); setEntryId('');setAdjustmentScope(''); setScaleId(''); setDeptId(''); setJobTitleId(''); setSelectedEmployee(null); setAdjustmentName(''); setAdjustmentType('');setAdjustmentCategory(''); setCalculationMethod('');setPercentageValue('');setFixedAmount('');setIsActive('Yes');setEffectiveDate([]);setEndDate([]);setAdjustmentDescription(''); }}
                                        >
                                        <span className="d-none d-sm-inline-block me-2">Add Pay Adjustment</span></Button>}
                                    </div> 
                                    
                                </Row>
                                </CardBody>
                            </Card>
                            
                            <Card>
                        <h5 className="card-header bg-transparent border-bottom text-uppercase">EDUCATION</h5>
                            <CardBody>
                                <Row  className="justify-content-center">
                                 
                                    <div className="table-responsive">
                                        <Table className="table table-sm mb-3 table-hover">
                                        <thead>
                                            <tr>
                                            <th>No</th>
                                            <th>Level</th>
                                            <td></td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                        {educationList.map((d,k)=>(
                                            <tr key={k}>
                                                <th scope="row">{k+1}</th>
                                                <td>{d}</td>
                                                <td style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '1rem' }}> <>
                                                    <div className="d-flex gap-3">
                                                        <Link
                                                        to="#"
                                                        className="text-success"
                                                        //onClick={() => handleEditJobH(l)}
                                                        >
                                                        <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
                                                        <UncontrolledTooltip placement="top" target="edittooltip">
                                                            Edit
                                                        </UncontrolledTooltip>
                                                        </Link>
                                                        <Link
                                                        to="#"
                                                        className="text-danger"
                                                        //onClick={() => handleDeleteJobH(l)}
                                                        >
                                                        <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
                                                        <UncontrolledTooltip placement="top" target="deletetooltip">
                                                            Delete
                                                        </UncontrolledTooltip>
                                                        </Link>
                                                    </div>
                                                    </></td>
                                              
                                            </tr>
                                        ))} 
                                        </tbody>
                                        </Table>
                                    </div>
                                    <div className="col-auto">
                                    {isLoading?<Button color="warning" type="button" className="btn-rounded btn-sm">Please wait...</Button>:<Button color="primary" className="btn-sm btn-rounded"
                                        >
                                        <span className="d-none d-sm-inline-block me-2">Add Education Level</span></Button>}
                                    </div> 
                                   
                                </Row>
                                </CardBody>
                            </Card>
                            </Col>
                            <Col xl={6}>
                            <Card>
                            <h5 className="card-header bg-transparent border-bottom text-uppercase">Departments</h5>
                                <CardBody>
                                <Row className="justify-content-center">
                                
                                <div className="table">
                                  <Table className="table table-sm m-0">
                                    <thead>
                                      <tr>
                                        <th>No</th>
                                        <th>Name</th>
                                        <th></th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                    {depts.map((c,k)=>(
                                      <tr key={k}>
                                        <td>{k+1}</td>
                                        <td>{c.name}</td>
                                        <td style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '1rem' }}> <>
                                                    <div className="d-flex gap-3">
                                                        <Link
                                                        to="#"
                                                        className="text-success"
                                                        onClick={()=>{ tog_dept(); setIsEdit(true); setDeptId(c.id); setDeptName(c.name)}}
                                                        >
                                                        <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
                                                        <UncontrolledTooltip placement="top" target="edittooltip">
                                                            Edit
                                                        </UncontrolledTooltip>
                                                        </Link>
                                                        <Link
                                                        to="#"
                                                        className="text-danger"
                                                        //onClick={() => handleDeleteJobH(l)}
                                                        >
                                                        <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
                                                        <UncontrolledTooltip placement="top" target="deletetooltip">
                                                            Delete
                                                        </UncontrolledTooltip>
                                                        </Link>
                                                    </div>
                                                    </></td>
                                       
                                      </tr>
                                    ))} 
                                    </tbody>
                                                          
                                  </Table>
                                </div>
                                <div className="col-auto">
                                    {isLoading?<Button color="warning" type="button" className="btn-rounded btn-sm">Please wait...</Button>:<Button color="primary" className="btn-sm btn-rounded" onClick={()=>{ tog_dept(); setDeptId(''); setDeptName(''); setIsEdit(false); }}
                                        >
                                        <span className="d-none d-sm-inline-block me-2">Add Department</span></Button>}
                                    </div> 
                         </Row>
                                </CardBody>
                            </Card>
                        <Card>
                        <h5 className="card-header bg-transparent border-bottom text-uppercase">Staff Titles</h5>
                            <CardBody>
                            <Row className="justify-content-center">
                                   
                                    <div className="table-responsive">
                                        <Table className="table table-sm mb-3 table-hover">
                                        <thead>
                                            <tr>
                                            <th>No</th>
                                            <th>Title</th>
                                            <th>Reports to</th>
                                            <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                        {rolesList.map((d,k)=>(
                                            <tr key={k} >
                                                <th scope="row">{k+1}</th>
                                                <td>{d.title}</td>
                                                <td>{d.reportsToName}</td>
                                                <td style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '1rem' }}> <>
                                                    <div className="d-flex gap-3">
                                                        <Link
                                                        to="#"
                                                        className="text-success"
                                                        onClick={()=>{ tog_title(); setIsEdit(true); setTitleId(d.id); setTitle(d.title); setReportsTo(d.reportsTo)}}
                                                        >
                                                        <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
                                                        <UncontrolledTooltip placement="top" target="edittooltip">
                                                            Edit
                                                        </UncontrolledTooltip>
                                                        </Link>
                                                        <Link
                                                        to="#"
                                                        className="text-danger"
                                                        //onClick={() => handleDeleteJobH(l)}
                                                        >
                                                        <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
                                                        <UncontrolledTooltip placement="top" target="deletetooltip">
                                                            Delete
                                                        </UncontrolledTooltip>
                                                        </Link>
                                                    </div>
                                                    </></td>
                                                
                                            </tr>
                                        ))}
                                            
                                        </tbody>
                                        </Table>
                                    </div>
                                    <div className="col-auto">
                                    {isLoading?<Button color="warning" type="button" className="btn-rounded btn-sm">Please wait...</Button>:<Button color="primary" className="btn-sm btn-rounded" onClick={()=>{ tog_title(); setTitleId(''); setTitle(''); setReportsTo(''); setIsEdit(false); }}
                                        >
                                        <span className="d-none d-sm-inline-block me-2">Add Job Title</span></Button>}
                                    </div> 
                                
                                    <Row>
                                        
                                    </Row>
                                    
                                    
                                </Row>
                                </CardBody>
                            </Card>
                            </Col>
                        </Row>
                        </div>
                    </Container>
                </div>
         
            </>
        );
    }

export default HumanResourceSettings;